import { logUsage } from 'owa-analytics';

export const enum ComposeScenario {
    Send = 0,
    Save = 1,
    Discard = 2,
}

export function logSmartReplyDatapoint(scenario: ComposeScenario, smartReplyExtractionId: string) {
    if (!smartReplyExtractionId) {
        // Nothing to log -- compose instance not created via smart reply.
        return;
    }

    let eventName: string = null;
    switch (scenario) {
        case ComposeScenario.Send:
            eventName = 'SmartReplySendMessage';
            break;
        case ComposeScenario.Save:
            eventName = 'SmartReplySaveMessage';
            break;
        case ComposeScenario.Discard:
            eventName = 'SmartReplyDiscardMessage';
            break;
    }

    logUsage(eventName, [smartReplyExtractionId]);
}
